import React from 'react';
import { TableActionButtons } from 'widgets/Table';
import { TableToolbarButtons } from 'widgets/Table';
import ExpandedRow from 'widgets/Table/ExpandedRow';

const useTableFilteredChildren = (children) => {
  const elements = {
    actionButtons: [],
    toolbarButtons: null,
    expandedRow: null,
  };
  React.Children.forEach(children, (child) => {
    if (child.type === TableActionButtons) {
      React.Children.forEach(child.props.children, (action) => elements.actionButtons.push(action));
    }
    if (child.type === TableToolbarButtons) {
      elements.toolbarButtons = child;
    }
    if (child.type === ExpandedRow) {
      elements.expandedRow = child;
    }
  });

  return elements;
};

export default useTableFilteredChildren;
